import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AlertaService } from "../../services/alerta.service";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { of } from "rxjs";
import { findBenefitCatalogAct, loadBenefitCatalogByIdAct, saveBenefitCatalogAct, saveSuccessBenefitCatalogAct, 
    setViolationsBenefitCatalogAct, showMsgErrorAct, updateBenefitCatalogAct, updateSuccessBenefitCatalogAct } from "./benefit-catalog.action";
import { BenefitCatalogService } from "../../services/benefit-catalog.service";


@Injectable()
export class BenefitCatalogEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private benefitCatalogService = inject(BenefitCatalogService);
    private alerta = inject(AlertaService);

    findBenefitCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findBenefitCatalogAct),
            exhaustMap(action => this.benefitCatalogService.findBenefitCatalogById(action.id)
                .pipe(
                    map(benefit => loadBenefitCatalogByIdAct({ benefit })),
                    catchError(error => {
                        if(error.status == 500) {
                            this.alerta.error("Se ha precentado un error interno", {
                                detail: error.error.details ,
                                onAccept: () => {
                                  this.router.navigate(['/benefitsCatalog']);
                                }}); // . stack -> mas detalle
                            return of();
                        }else {
                            //return of(showMsgErrorAct({ error }));
                            this.alerta.error("Se ha precentado un error interno: ", {detail: error.message});
                            return of();
                        }
                    })
                ))
        )
    );

    saveBenefitCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveBenefitCatalogAct),
            exhaustMap(action => this.benefitCatalogService.createBenefitCatalog(action.benefitNew)
                .pipe(
                    map(benefitNew => saveSuccessBenefitCatalogAct({ benefitNew })),
                    /*catchError(error => (error.status == 400) ? of(setViolationsBenefitCatalogAct({ benefitForm: action.benefitNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                    : of(showMsgErrorAct({ error }))*/
                    catchError(error => (error.status == 400) ? 
                        of(setViolationsBenefitCatalogAct({ benefitForm: action.benefitNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                        : of(showMsgErrorAct({ error }))
                    //)
                    )
                )
            )
        )
    );

    /*showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
        tap((action) => {
            this.alerta.error("Se ha precentado un error interno");
        })
    ), { dispatch: false });*/
    showMsgErrorEffect$ = createEffect(() =>
            this.actions$.pipe(
              ofType(showMsgErrorAct),
              tap(action => {
                const detail = action.error?.error?.message || action.error?.message || null;
                //console.log('showMsgErrorEffect 111:');
                this.alerta.error(
                  'Se ha presentado un error interno Catalogo Beneficios',
                  detail ? { detail } : undefined
                );
                //console.log('showMsgErrorEffect 222:');
              })
            ),
            { dispatch: false }
          );

    saveSuccessBenefitCatalogEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessBenefitCatalogAct),
        tap(() => {
            this.router.navigate(['/benefitsCatalog']);
            this.alerta.correct("Beneficio creado con exito!");
        })
    ), { dispatch: false });

    updateBenefitCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateBenefitCatalogAct),
            exhaustMap(action => this.benefitCatalogService.updateBenefitCatalog(action.benefitUpdated)
                .pipe(
                    map(benefitUpdated => updateSuccessBenefitCatalogAct({ benefitUpdated })),
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsBenefitCatalogAct({ benefitForm: action.benefitUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }
                    })
                )
            )
        )
    );

    updateSuccessBenefitCatalogEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessBenefitCatalogAct),
        tap(() => {
            this.router.navigate(['/benefitsCatalog']);
            this.alerta.correct("Beneficio editado con exito!");
        })
    ), {dispatch: false});

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
    
}